export default __webpack_public_path__ + "static/media/bg20.63f0604c.jpg";